import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PresupuestoIaService } from "./IA/presupuesto-ia.service";
import { CookieService } from "ngx-cookie-service";
import { companiesSegPresupuestal } from "../../shared/catalogos";
import { PresupuestoManualService } from "./Manual/presupuesto-manual.service";
import { cuentaEntity, detalleCuentaEntity, detalleIndicadorEntity, evaluacionesAllEntity, evaluacionesEntity, gruposIndEntity, indicadorEntity, modIndEntity, sucursalesEntity, varTipoEntity } from "./Manual/entities";

export interface PresupuestoServiceInterface{
  // getEscenarios(params: any): Observable<any>;
  getSucursales(params: sucursalesEntity): Observable<any>;
  getPeriodos(params: evaluacionesEntity): Observable<any>;
  getPeriodosAll(params: evaluacionesAllEntity): Observable<any>;
  getCuentasDescripcion(params: cuentaEntity): Observable<any>;
  getCuentasValor(params: detalleCuentaEntity): Observable<any>;
  getModuloIndicador(params: modIndEntity): Observable<any>
  getgrupoInd(params: gruposIndEntity): Observable<any>
  getIndicadoresPropiedades(params: indicadorEntity): Observable<any>
  getIndicadoresDescripcion(params: indicadorEntity): Observable<any>
  getIndicadoresValor(params: detalleIndicadorEntity): Observable<any>
  getindicadorGrupo(grupoIndicador: number): Observable<any>
  getVariableTipoDescripcion(params: varTipoEntity): Observable<any>
  getVariableTipoValor(params: varTipoEntity): Observable<any>
}

@Injectable({providedIn: 'root'})
export class SegPresupuestalFactory {
  constructor(
    private iaService: PresupuestoIaService,
    private manualService: PresupuestoManualService,
    public cookies: CookieService,
  ){}

  public getService(): PresupuestoServiceInterface{
    const idAdmi = this.cookies.get('idInstitucion');
    const type = companiesSegPresupuestal.find( c => c.id === idAdmi ).back;
    //TODO cuando se implementen multiples backs se descomenta la linea inferior y se elimina el return actual
    // return type === 1 ? this.manualService : this.iaService;
    return this.manualService;
  }

  
}